// theme colors
export enum Colors {
  fresh = "#8ac0b8",
  red = "#fc4a1a",
  lightGray = "#7A7A7A",
  white = "#fff",
  black = "#000",
}

// for color picker
export enum PickerColors {
  white = "#fff",
  red = "#f28b82",
  blue = "#cbf0f8",
  yellow = "#fff475",
  green = "#ccff90",
  brown = "#e6c9a8",
  gray = "#e8eaed",
  orange = "#fbbc04",
}

// FlexBox variables
export enum AlignItems {
  baseline = "baseline",
  center = "center",
  end = "fle-end",
  start = "flex-start",
  stretch = "stretch",
  inherit = "inherit",
}

export enum JustifyContent {
  baseline = "baseline",
  center = "center",
  end = "flex-end",
  start = "flex-start",
  stretch = "stretch",
  spaceBetween = "space-between",
  spaceAround = "space-around",
}

export enum FlexWrap {
  wrap = "wrap",
  nowrap = "nowrap",
  inherit = "inherit",
  unset = "unset",
  wrapReverse = "wrap-reverse",
}
